<template>
    <PopupOverlay
        ref="popup"
        class="-mx-6 -mt-5"
        @close="closeEditPopup"
    >
        <PostEditForm
            ref="form"
            v-bind="$attrs"
        ></PostEditForm>
        <transition name="fade">
            <p
                v-if="validation.errors.files"
                class="px-3 text-red-600 text-sm hidden md:block"
                v-text="validation.errors.files"
            ></p>
        </transition>

        <template #mobile>
            <PostEditFormMobile v-bind="$attrs"></PostEditFormMobile>
            <transition name="fade">
                <p
                    v-if="validation.errors.files"
                    class="px-3 text-red-600 text-sm hidden md:block"
                    v-text="validation.errors.files"
                ></p>
            </transition>
        </template>
    </PopupOverlay>
</template>

<script>
import PopupOverlay from '@components/PopupOverlay';
import { decodeEntities } from '@/helpers/string';
import PostEditForm from './PostEditForm.vue';
import PostEditFormMobile from './PostEditFormMobile.vue';

export default {
    name: 'PostEdit',
    components: { PostEditFormMobile, PostEditForm, PopupOverlay },
    provide() {
        return {
            avatar: this.avatar,
            context: this.context,
            post: this.post,
            photo: this.photo,
            validation: this.validation,
        };
    },
    inheritAttrs: false,

    props: {
        postObject: {
            type: Object,
            required: true,
        },
    },
    emits: ['close-edit'],

    i18nOptions: {
        namespaces: ['post'],
    },

    data() {
        return {
            postId: this.postObject.postDetails.id,
            context: {
                id: this.postObject[this.postObject.postDetails.context].id,
                type: this.postObject.postDetails.context,
            },
            post: {
                questionId: this.postObject.postDetails.id,
                text: decodeEntities(this.postObject.postDetails.content),
                postAnonymous: !!this.postObject.postDetails.isAnonymous,
                hasPoll: this.postObject.postDetails.poll !== null,
                hasPhoto: this.postObject.postDetails.files.length !== 0,
                vue: true,
            },
            photo: {
                files: this.postObject.postDetails.files,
                deleteFiles: [],
            },
            validation: {
                errors: {},
                hasErrors: false,
            },
        };
    },

    computed: {
        avatar() {
            const details = this.postObject.postDetails;
            const { user } = details;

            return {
                name: details.isAnonymous ? details.anonymousUser.name : user.name,
                picture: details.isAnonymous
                    ? `/${details.anonymousUser.icon}`
                    : (user.profilePictureUrl ?? user.avatarPictureUrl),
            };
        },
        editPopupIsOpen() {
            return this.$store.getters['post/editPopupIsOpen'](this.postId);
        },
    },

    watch: {
        editPopupIsOpen(value, oldValue) {
            if (oldValue === undefined) return;
            if (value) {
                this.$refs.popup.open();
            } else {
                this.$refs.popup.close();
                this.$refs.form.resizeTextarea();
                this.$emit('close-edit');
            }
        },
    },

    mounted() {
        setTimeout(() => {
            this.$store.dispatch('post/openEditPopup', this.postId);
        }, 50);
    },

    methods: {
        closeEditPopup() {
            this.$store.dispatch('post/closeEditPopup', this.postId);
        },
    },
};
</script>
